import { useState, createContext, useContext } from "react";
const useUserCntx = createContext();
const setUserCntx = createContext();
export function UserCntx({ children }) {
    const [stUser, setStUser] = useState({});
    return (
        <useUserCntx.Provider value={stUser}>
            <setUserCntx.Provider value={setStUser}>
                {children}
            </setUserCntx.Provider>
        </useUserCntx.Provider>
    )
}
export function UseUser() {
    return useContext(useUserCntx);
}
export function SetUser() {
    return useContext(setUserCntx);
}